@if (hasAnyContent) {
<div class="appointments-card">
  <div class="section-label section-label--brand">Mes prochaines convocations</div>
  <div class="dash-card dash-card--columns">
    @if (convocationsAvailable) {
    <div class="column">
      <div class="subsection-label">Convocations</div>
      <app-my-convocations></app-my-convocations>
    </div>
    }
    @if (bookingsAvailable) {
    <div class="column">
      <div class="subsection-label">Commandes de matériel</div>
      <app-my-bookings></app-my-bookings>
    </div>
    }
  </div>
</div>
}
